import { ResultOf } from 'gql.tada';
import { gql } from '../../gql';

export const GET_WATER_SUPPLIER_IDS = gql(`
  query GetWaterSupplierIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSuppliers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["profileId"]
    ) {
      profileId
    }
  }
`);

export const GET_WATER_SUPPLIERS = gql(`
  query GetWaterSuppliers(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSuppliers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      profileId
      hasUser
      profile {
        id
        name
        phones {
          value
        }
        emails {
          value
        }
        contactAddress {
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
    }
  }
`);

export type WaterSupplierItem = ResultOf<
  typeof GET_WATER_SUPPLIERS
>['waterSuppliers'][number];
